import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  Stack,
  Button,
  Paper,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import chatApi from '../../api/chatApi';
import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { formatDate } from '../../utils/dateFormatter';

export default function ChatListPageDesktop() {
  const { user } = useContext(AuthContext);
  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRooms();
  }, []);

  const fetchRooms = async () => {
    try {
      const res = await chatApi.listRooms();
      setRooms(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container>
      <BackButtonDesktop />

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Chat
        </Typography>

        <ProtectedAction user={user} roles={['ADMIN']}>
          <Button
            variant="contained"
            onClick={() => navigate('/chatroomcreate')}
          >
            Nuova stanza
          </Button>
        </ProtectedAction>
      </Stack>

      <Stack spacing={2}>
        {rooms.map(room => (
          <Paper
            key={room.id}
            sx={{
              p: 2,
              cursor: 'pointer'
            }}
            onClick={() => navigate(`/chatroom/${room.id}`)}
          >
            <Typography variant="h6">
              {room.name}
            </Typography>

            <Typography variant="body2">
              Tipo: {room.type}
            </Typography>

            <Typography variant="caption">
              Creata il: {formatDate(room.createdAt)}
            </Typography>
          </Paper>
        ))}
      </Stack>
    </Container>
  );
}